import { VCol } from 'vuetify/lib/components/VGrid';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loader-container"},[_c(VRow,{staticClass:"fill-height",attrs:{"align":"center","justify":"center"}},[_c(VCol,{attrs:{"cols":"auto"}},[(_vm.type === 'overlay')?_c(VOverlay):_vm._e()],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }